import { z } from "zod";

export const zAttrContentLanguage = z.object({
  editor: z.literal("ContentLanguage"),
});
export type ZAttrContentLanguage = z.infer<typeof zAttrContentLanguage>;
